module.exports = __webpack_public_path__ + "static/media/mahall.eff30965.png";